import React from 'react';
import './Kanban.css'; // Reutiliza os mesmos estilos

// Usamos React.memo para evitar re-renderizações desnecessárias dos cards
// se apenas a ordem deles mudar, mas o conteúdo não.
const KanbanCard = React.memo(({ os, onDoubleClick }) => {

  const formatDate = (dateString) => {
    // Corrige o problema do fuso horário na exibição
    return new Date(dateString).toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
    });
  };

  return (
    <div className="kanban-card" onDoubleClick={() => onDoubleClick(os)}>
      {/* Nome do Cliente */}
      <div className="card-title">{os.cliente?.nome || 'Cliente não definido'}</div>
      
      {/* Data */}
      <div className="card-detail">
        <strong>Data:</strong> {formatDate(os.data)}
      </div>

      {/* Codigo */}
      <div className="card-detail">
        <strong>Código:</strong> {os.codigo || 'N/A'}
      </div>

      {/* Unidade */}
      <div className="card-detail">
        <strong>Unidade:</strong> {os.unidade?.nome || 'N/A'}
      </div>

      {/* Classificacao */}
      <div className="card-detail">
        <strong>Classif.:</strong> {os.classificacao?.nome || 'N/A'}
      </div>
      
      {/* Fornecedor */}
      <div className="card-detail">
        <strong>Forn.:</strong> {os.fornecedor?.nome || 'N/A'}
      </div>
      
      {/* Responsavel */}
      {os.responsavelExecucao && (
        <div className="card-detail card-responsavel">
          <strong>Resp.:</strong> {os.responsavelExecucao.nome}
        </div>
      )}
    </div>
  );
});

export default KanbanCard;